import React from 'react';
import PropTypes from 'prop-types';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { formatCurrency } from '../hooks/useGoalsVsActual';

const MAX_PROGRESS = 100;

export function GoalProgressItem({ goal }) {
  const progress =
    goal.targetAmount > 0
      ? Math.min((goal.actualAmount / goal.targetAmount) * MAX_PROGRESS, MAX_PROGRESS)
      : 0;

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="baseline" mb={0.5}>
        <Typography variant="subtitle2">{goal.categoryName}</Typography>

        <Typography variant="caption" color="text.secondary">
          Meta {goal.targetPercentage}% · Realizado {goal.actualPercentage.toFixed(1)}%
        </Typography>
      </Stack>

      <LinearProgress
        variant="determinate"
        value={progress}
        color={goal.status}
        sx={{ height: 8, borderRadius: 4 }}
      />

      <Typography variant="caption" color="text.secondary">
        {formatCurrency(goal.actualAmount)} de {formatCurrency(goal.targetAmount)}
      </Typography>
    </Box>
  );
}

GoalProgressItem.propTypes = {
  goal: PropTypes.shape({
    categoryName: PropTypes.string.isRequired,
    targetPercentage: PropTypes.number.isRequired,
    targetAmount: PropTypes.number.isRequired,
    actualAmount: PropTypes.number.isRequired,
    actualPercentage: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};
